import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import ArtParcel from './Pages/ArtParcel';
import InventoryPage from './Pages/InventoryPage';
import AuthPage from './Pages/AuthPage';
import StorePage from './Pages/StorePage';
import FreeDrawPage from './Pages/FreeDrawPage';
import UserProfile from './Pages/UserProfile';
import AboutPage from './Pages/AboutPage';
import Layout from './Layout';
import EventsPage from './Pages/EventsPage';
import RewardsPage from './Pages/RewardsPage';
import SupportPage from './Pages/SupportPage';
import NotFoundPage from './Pages/NotFoundPage';
import TermsPage from './Pages/Terms/TermsPage';
import PrivacyPage from './Pages/Terms/PrivacyPage';
import RefundPolicyPage from './Pages/Terms/RefundPage';
import UserSettingsPage from './Pages/UserSettings';

const Main = () => {
  return (
      <Routes> {/* The Switch decides which component to show based on the current URL.*/}
        {/* Redirect root path to /A */}
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="PlaceCanvas" replace />} />
          <Route path="Canvas/:pageId" element={<ArtParcel />} />
          <Route path='Canvas/:pageId/:artworkId' element={<ArtParcel />} /> {/* Dynamic route */}
          
          <Route exact path='Auth' element={<AuthPage />} />

          <Route path='Inventory' element={<Navigate to="/Inventory/Artwork" replace />} />
          <Route path='Inventory/:category' element={<InventoryPage />} />

          <Route exact path='Shop' element={<StorePage />} />

          <Route exact path='About' element={<AboutPage />} />
          
          <Route path="PlaceCanvas" element={<FreeDrawPage />} />
          <Route path="PlaceCanvas/:pageId" element={<FreeDrawPage />} />

          <Route path='User/:username' element={<UserProfile />} />

          {/*<Route path="Events" element={<EventsPage />} />

          <Route path='Events/:pageId' element={<ArtParcel />} />
          
          <Route path="Rewards" element={<RewardsPage />} />
          
          <Route path="Settings" element={<UserSettingsPage />} />*/}

          <Route path="Support" element={<SupportPage />} />

          <Route path="Terms/Terms" element={<TermsPage />} />

          <Route path="Terms/Privacy" element={<PrivacyPage />} />

          <Route path="Terms/Refunds" element={<RefundPolicyPage />} />

          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
  );
}

export default Main;